export const API_ENDPOINTS = {
  base: '/api/v2/loyaltyProgram',
  profile: '/api/v2/user/profile',
  professional: '/api/v2/loyaltyProgram/customer/relationship',
  regions: '/api/boitata/v1/regions',
  profileLoyalty: '/api/v2/loyaltyProgram/profile',
  profileBalance: '/api/v2/loyaltyProgram/balance',
  coupon: '/api/v2/loyaltyProgram/vouchers',
  customers: '/api/v2/loyaltyProgram/relationship',
  customerInvite: 'api/v2/loyaltyProgram/relationship/invite',
  relationship: '/api/v2/loyaltyProgram/customer/relationship',
  stores: region => `/api/boitata/v1/regions/${region}/stores`,
  signUpInformation: region => `/api/v2/loyaltyProgram/signUpInformation/${region}`,
  notifications: '/api/v2/loyaltyProgram/notifications',
  vouchers: type => {
    const voucherTypes = {
      money: '/api/v2/loyaltyProgram/vouchers/money',
      moneyActivated: '/api/v2/loyaltyProgram/vouchers/money/activated',
      advantages: '/api/v2/loyaltyProgram/advantages',
      active: '/api/v2/loyaltyProgram/vouchers/activate'
    }
    return voucherTypes[type]
  }
}
